import styled from 'styled-components';

export const CellText = styled.div`
  font-size: 14px;
  text-decoration: ${p => p.isFinished && 'line-through'};
  color: ${p => p.isFinished && p.theme.color.label};
`;

